import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ReactHtmlParser from "react-html-parser";
import { GetSubjectContentServiceAdmin, GetSubjectsService } from '../services/QualificationService';
import TeamBox from '../components/course/TeamBox';

function CourseOverview() {
    const { sid, qid, stdId } = useParams()
    const [state, setState] = useState({});

    const updateSubject = () => {
            GetSubjectContentServiceAdmin({ sid: sid, id:stdId })
              .then((res) => {
                setState({ subjectContent: res.data });
              })
              .catch((error) => {});
      };

      useEffect(() => {
        updateSubject()
      }, [])
      

    return (
        <div class="p-4 course_full_vh">
            <div
                role="tabpanel"
                aria-labelledby="pills-Overview-tab"
            >
                {state && state.subjectContent && state.subjectContent.subject && state.subjectContent.subject ? (
                    <div className="Actabs">
                        <div className='course-overview-box'>
                            {state.subjectContent.subject.welcome || Object.keys(state?.subjectContent?.team).length > 0 ? (
                                <>
                                    {state.subjectContent.subject.welcome ? ReactHtmlParser(state.subjectContent.subject.welcome) : null}
                                    {state.subjectContent.subject.welcome && Object.keys(state?.subjectContent?.team).length > 0 ? <hr style={{ margin: "20px 0" }} /> : null}
                                    {Object.keys(state?.subjectContent?.team).length > 0 ? <TeamBox teamData={state?.subjectContent?.team} /> :null }
                                </>
                            ) : (
                                <div className="subject-sub-header">
                                    <h3>No Content Available.</h3>
                                </div>
                            )}
                        </div>
                    </div>
                ) : <>
                    <div className="subject-sub-header">
                        <h3>No Content Available.</h3>
                    </div>
                </>}
            </div>
        </div>
    )
}

export default CourseOverview